import DataAction from "./DataAction";


export default class DataReducer {

    static MONTHS = [
        'januari',
        'februari',
        'maart',
        'april',
        'mei',
        'juni',
        'juli',
        'augustus',
        'september',
        'oktober',
        'november',
        'december',
    ];

    static initialState = {

        dateTime: false,
        form: false,
        wishes: false,
        checkmark: false,
        error: false,
        currentStep: 1,
        selectedTime: null,
        selectedDayName: null,
        selectedDayNum: null,
        selectedMonth: this.MONTHS[new Date().getMonth()],
        selectedYear: new Date().getFullYear(),
        selectedOptions: [],
        selectedRemark: null,
        submitChecker: {
            data: false,
            error: false
        },
    }

    static reducer(state = DataReducer.initialState, action) {
        switch (action.type) {
            case DataAction.REQUEST_DATA:
                return {
                    ...state,
                    dateTime: false,
                    form: false,
                    checkmark: false,
                    wishes: false,
                    error: false
                };
            case DataAction.REQUEST_DATA + '_FINISHED':
                return {
                    ...state,
                    dateTime: action.payload.dateTime,
                    form: action.payload.form,
                    checkmark: action.payload.checkmark,
                    wishes: action.payload.wishes,
                    error: false

                };
            case DataAction.SUBMIT_HANDLER:
                return {
                    ...state,
                    submitChecker: {
                        error: false,
                        data: false
                    }
                };
            case DataAction.SUBMIT_HANDLER + '_FINISHED':
                return {
                    ...state,
                    submitChecker: {
                        error: action.payload.error,
                        data: action.payload.data
                    },
                };
            case DataAction.SET_MONTH_DATA:
                return {
                    ...state,
                    selectedMonth: null,
                    selectedYear: null
                };
            case DataAction.SET_MONTH_DATA + '_FINISHED':
                return {
                    ...state,
                    selectedMonth: action.payload.selectedMonth,
                    selectedYear: action.payload.selectedYear
                };
            case DataAction.SET_DAY_DATA:
                return {
                    ...state,
                    selectedDayName: null,
                    selectedDayNum: null,
                };
            case DataAction.SET_DAY_DATA + '_FINISHED':
                return {
                    ...state,
                    selectedDayName: action.payload.selectedDayName,
                    selectedDayNum: action.payload.selectedDayNum
                };
            case DataAction.SET_TIME_DATA:
                return {
                    ...state,
                    selectedTime: null,
                };
            case DataAction.SET_TIME_DATA + '_FINISHED':
                return {
                    ...state,
                    selectedTime: action.payload.selectedTime,
                };
            case DataAction.SET_OPTION_DATA:
                return {
                    ...state,
                    selectedOptions: [],
                };
            case DataAction.SET_OPTION_DATA + '_FINISHED':
                return {
                    ...state,
                    selectedOptions: action.payload.selectedOptions,
                };
            case DataAction.SET_REMARK_DATA:
                return {
                    ...state,
                    selectedRemark: null,
                };
            case DataAction.SET_REMARK_DATA + '_FINISHED':
                return {
                    ...state,
                    selectedRemark: action.payload.selectedRemark,
                };
            case DataAction.NEXT_STEP:
                return {
                    ...state,
                    currentStep: state.currentStep,
                };
            case DataAction.NEXT_STEP + '_FINISHED':
                return {
                    ...state,
                    currentStep: state.currentStep + 1,
                };
            case DataAction.NAV_STEP:
                return {
                    ...state,
                    currentStep: state.currentStep,
                };
            case DataAction.NAV_STEP + '_FINISHED':

                let stepHandler = state.currentStep
                if (state.currentStep > action.payload.locatingStep){
                    stepHandler = action.payload.locatingStep
                }
                return {
                    ...state,
                    currentStep: stepHandler,
                };
            default:
                return state;

        }
    }

}
